<template>
  <div class="container_content" id="nodeS2">
    <!-- 底图 -->
    <img src="@/common/images/nodeService/dfhj_bg2.png" class="dfhj_bg2" />
    <!-- content -->
    <div class="dfhj2_content">
      <img src="@/common/images/nodeService/dfhj_c2.png" class="dfhj_c2" />
    <img src="@/common/images/nodeService/dot.gif" class="dot_gif" />
    <img src="@/common/images/nodeService/dot.gif" class="dot_gif2" />
      <div class="line_img">
        <img src="@/common/images/nodeService/dfhj_c2_bg.png" class="line_imgbg" />
        <div class="line_content">
          <vue-seamless-scroll :data="imgList" :class-option="defaultOption2">
          <div class="line_img_item" v-for="(item,index) in imgList" :key="index">
            <img :src="item.imgUrl" class="item_img" />
          </div>
        </vue-seamless-scroll>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
  import VueSeamlessScroll from "vue-seamless-scroll"
  export default {
    components: {
      VueSeamlessScroll
    },
    data() {
      return {
        imgList: [{
          imgUrl: require('@/common/images/nodeService/dfhj_c2_img.png'),
        }, {
          imgUrl: require('@/common/images/nodeService/dfhj_c2_img.png'),
        }, {
          imgUrl: require('@/common/images/nodeService/dfhj_c2_img.png'),
        }, {
          imgUrl: require('@/common/images/nodeService/dfhj_c2_img.png'),
        }, {
          imgUrl: require('@/common/images/nodeService/dfhj_c2_img.png'),
        }, {
          imgUrl: require('@/common/images/nodeService/dfhj_c2_img.png'),
        }, {
          imgUrl: require('@/common/images/nodeService/dfhj_c2_img.png'),
        }]
      }
    },
    mounted() {

    },
    computed: {

      defaultOption2() {
        return {
          step: 1, // 数值越大速度滚动越快
          limitMoveNum: 1, // 开始无缝滚动的数据量 this.item4List.length
          hoverStop: true, // 是否开启鼠标悬停stop
          direction: 2, // 0向下 1向上 2向左 3向右
          openWatch: true, // 开启数据实时监控刷新dom
          singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
          // waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
        }
      }
    },
    methods: {

    }
  }
</script>

<style>
  .container_content {
    position: relative;
    margin-top: -88px;
  }

  .dfhj_bg2 {
    width: 290px;
    height: 664px;
    position: absolute;
    top: 256px;
    left: 0;
    z-index: 0;
    animation-name: zoomIn;
    animation-duration: 3s;
  }

  .dfhj2_content {
    width: 1920px;
    height: 1147px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .dfhj_c2 {
    width: 1339px;
    height: 631px;
    animation-name: zoomIn;
    animation-duration: 3s;
    margin-top: 130px;
  }

  .line_img {
    width: 1397px;
    height: 314px;
    position: relative;
    margin-top: 68px;
    display: flex;
    flex-direction: row;
    overflow: hidden;
    white-space: nowrap;
    align-items: center;
    justify-content: center;
  }

  .line_imgbg {
    width: 1397px;
    height: 314px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    animation-name: zoomIn;
    animation-duration: 4s;
  }

  .line_content {
    width: 1220px;
    height: 314px;
    display: flex;
    flex-direction: row;
    overflow: hidden;
    white-space: nowrap;
    align-items: center;
    justify-content: center;
    top: 0;
    left: 40px;
    z-index: 9;
  }

  .line_img_item {
    width: 247px;
    height: 165px;
    margin: 0 20px;
    display: inline-block;
  }

  .item_img {
    width: 247px;
    height: 165px;
  }

  .dot_right {
    width: 207px;
    height: 232px;
    position: absolute;
    right: 220px;
    top: 80px;
    animation-name: bounceInRight;
    animation-duration: 4s;
    animation-delay: -1s;
  }


  .flipInX {
    animation-name: bounce;
    animation-duration: 1s;
    animation-iteration-count: 100;
  }
  .dot_gif{
    width: 30px;
    height:30px;
    position: absolute;
    left: 948px;
    top: 190px;
    animation-name: zoomIn;
    animation-duration: 3s;
  }
  .dot_gif2{
    width: 30px;
    height:30px;
    position: absolute;
    left: 948px;
    top: 348px;
    animation-name: zoomIn;
    animation-duration: 3s;
  }
</style>



// WEBPACK FOOTER //
// src/components/nodeS2.vue